import { on } from "@ngrx/store";
import { ApplicationStore } from "../../application.state";
import { CreditCheckActions } from "./credit-check.actions";
import { initialSubscriptionCreditCheckState } from "./credit-check.state";
import { CustomerActions } from "../../../pages/customer/customer.actions";
import { QuoteCreateActions } from "../../../pages/quote-create/quote/quote-create.actions";

// **************************************************************************
// CREDIT CHECK REDUCER (array format for spreading in parent)
// **************************************************************************

// **************************************************************************
// SUBSCRIPTION FLOW
// **************************************************************************

const runSubscriptionCheck = on(CreditCheckActions.runSubscriptionCheck, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                result: null,
                loading: true,
                overridden: false,
            },
        },
    },
}));

const runSubscriptionCheckSuccess = on(CreditCheckActions.runSubscriptionCheckSuccess, (state: ApplicationStore, { response }) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                result: response,
                loading: false,
            },
        },
    },
}));

const runSubscriptionCheckFailure = on(CreditCheckActions.runSubscriptionCheckFailure, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                loading: false,
            },
        },
    },
}));

const overrideSubscriptionDenial = on(CreditCheckActions.overrideSubscriptionDenial, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                overridden: true,
            },
        },
    },
}));

const updateSubscriptionCustomerCode = on(CreditCheckActions.updateSubscriptionCustomerCode, (state: ApplicationStore, { customerCode }) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                result: state.data.creditCheck.subscription.result
                    ? { ...state.data.creditCheck.subscription.result, customerCode }
                    : state.data.creditCheck.subscription.result,
            },
        },
    },
}));

const resetSubscription = on(CreditCheckActions.resetSubscription, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: initialSubscriptionCreditCheckState,
        },
    },
}));

// **************************************************************************
// CUSTOMER CREATED - Update customer code on subscription credit check
// **************************************************************************

const customerCreated = on(CustomerActions.createCustomerSuccess, (state: ApplicationStore, { customerCode }) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: {
                ...state.data.creditCheck.subscription,
                result: state.data.creditCheck.subscription.result
                    ? { ...state.data.creditCheck.subscription.result, customerCode }
                    : state.data.creditCheck.subscription.result,
            },
        },
    },
}));

// **************************************************************************
// QUOTE CREATED - Reset subscription credit check
// **************************************************************************

const quoteCreated = on(QuoteCreateActions.createSuccess, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            subscription: initialSubscriptionCreditCheckState,
        },
    },
}));

// **************************************************************************
// QUOTE FLOW (loading state only - result stored on Quote)
// **************************************************************************

const runQuoteCheck = on(CreditCheckActions.runQuoteCheck, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            quoteLoading: {
                ...state.data.creditCheck.quoteLoading,
                running: true,
            },
        },
    },
}));

const runQuoteCheckComplete = on(
    CreditCheckActions.runQuoteCheckSuccess,
    CreditCheckActions.runQuoteCheckFailure,
    (state: ApplicationStore) => ({
        ...state,
        data: {
            ...state.data,
            creditCheck: {
                ...state.data.creditCheck,
                quoteLoading: {
                    ...state.data.creditCheck.quoteLoading,
                    running: false,
                },
            },
        },
    }),
);

const overrideQuoteCheck = on(CreditCheckActions.overrideQuoteCheck, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            quoteLoading: {
                ...state.data.creditCheck.quoteLoading,
                overriding: true,
            },
        },
    },
}));

const overrideQuoteCheckComplete = on(
    CreditCheckActions.overrideQuoteCheckSuccess,
    CreditCheckActions.overrideQuoteCheckFailure,
    (state: ApplicationStore) => ({
        ...state,
        data: {
            ...state.data,
            creditCheck: {
                ...state.data.creditCheck,
                quoteLoading: {
                    ...state.data.creditCheck.quoteLoading,
                    overriding: false,
                },
            },
        },
    }),
);

export const creditCheckReducer = [
    // Subscription flow
    runSubscriptionCheck,
    runSubscriptionCheckSuccess,
    runSubscriptionCheckFailure,
    overrideSubscriptionDenial,
    updateSubscriptionCustomerCode,
    resetSubscription,
    // Cross-store reactions
    customerCreated,
    quoteCreated,
    // Quote flow
    runQuoteCheck,
    runQuoteCheckComplete,
    overrideQuoteCheck,
    overrideQuoteCheckComplete,
];
